import { render, staticRenderFns } from "./ChatEntries.vue?vue&type=template&id=8abeb512&scoped=true&"
import script from "./ChatEntries.vue?vue&type=script&lang=js&"
export * from "./ChatEntries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8abeb512",
  null
  
)

export default component.exports